import { Col, Row } from 'antd'
import { CSSProperties, ReactNode } from 'react'
import styled from 'styled-components'
export const HaupWrapper = styled.div.attrs({ id: 'mobile-wrapper' })`
  background: url('/haup_submission_bg.png') center center / cover no-repeat;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

export const MOBILE_WRAPPER_SCROLL_ID = 'mobile-wrapper-scroll'

interface MobileWrapperProps {
  children: ReactNode
  style?: CSSProperties
  rowStyle?: CSSProperties
  colStyle?: CSSProperties
}
export const MobileWrapper = (props: MobileWrapperProps) => {
  return (
    <HaupWrapper style={props.style}>
      <Row justify="center" style={{ height: '100%', ...props.rowStyle }}>
        <Col
          id={MOBILE_WRAPPER_SCROLL_ID}
          flex="0 1 500px"
          style={{
            height: '100%',
            overflow: 'auto',
            ...props.colStyle,
          }}
        >
          {props.children}
        </Col>
      </Row>
    </HaupWrapper>
  )
}
